import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    form: {
      maxWidth: "100%",
      margin: "auto",
      marginTop: theme.spacing(7),
      marginBottom: theme.spacing(10),
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    },
  })
);
